import React, {ReactNode, useEffect, useRef} from "react"
import {MutationState} from "@irati/utils/apollo"
import styled, {css} from "styled-components"
import Button from "@irati/ui/src/Button"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"

const Container = styled.div`
  ${({theme}) => css`
    background: ${theme.colors.greys.white};
    padding: ${theme.spacing.one};
    max-width: 300px;
    border-radius: 3px;
    box-shadow: ${theme.shadows.low};
  `}
`

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({theme}) => theme.spacing.one};
  justify-content: space-between;
`

interface Props extends InjectIntl {
  id: string
  apolloState: MutationState
  children: ReactNode | ReactNode[]
  onConfirm: () => void
  onCancel: () => void
  confirmLabel?: string
  cancelLabel?: string
  className?: string
}

const Confirm: React.FC<Props> = (props) => {
  const {onConfirm, onCancel, children, className, apolloState, intl} = props
  const contentRef = useRef<any>()

  useEffect(() => {
    if (!onCancel) {
      return
    }
    document.addEventListener("click", handleOutsideClick, true)

    return () => {
      document.removeEventListener("click", handleOutsideClick, true)
    }
  }, [])

  const handleOutsideClick = ({target}) => {
    const isClickingOutsideContent = contentRef.current && !contentRef.current.contains(target)

    if (isClickingOutsideContent) {
      onCancel?.()
    }
  }

  return (
    <Container className={className} ref={contentRef}>
      {children}
      <ButtonContainer>
        <Button id={id("btn-cancel", props)} onClick={onCancel}>
          {intl.formatMessage({id: props.cancelLabel})}
        </Button>
        <Button id={id("btn-confirm", props)} onClick={onConfirm} primary apolloState={apolloState}>
          {intl.formatMessage({id: props.confirmLabel})}
        </Button>
      </ButtonContainer>
      {apolloState?.error && <div>{intl.formatMessage({id: apolloState.errorMsg})}</div>}
    </Container>
  )
}
Confirm.defaultProps = {
  id: "confirm",
  confirmLabel: "recognition.confirm.confirmLabel",
  cancelLabel: "recognition.confirm.cancelLabel",
  onConfirm: () => {},
  onCancel: () => {},
  className: undefined
}
export default injectIntl(Confirm)
